// extracted by mini-css-extract-plugin
module.exports = {"scrollToTop":"main_scrollToTop_233CB","isHidden":"main_isHidden_d6r0N"};